const SHOPIFY_UTILS = (() => {
  /**
  * @returns the current shopify cart
  */
  async function getShopifyCart() {
    const shopifyResponse =await fetch(`${window.Shopify.routes.root}cart.json`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
      },
    });
    return shopifyResponse.json();
  }

  /**
  * Adds the item to the shopify cart. Throws on error; callers handle UI as needed.
  */
  async function addToShopifyCart({ variantId }) {
    if (!variantId) {
      throw new Error('No variantId provided to add to cart');
    }
    const res = await fetch(`${window.Shopify.routes.root}cart/add.json`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] }),
    });
    const data = await res.json();
    if (!res.ok || data.status === 422) {
      const msg = data.description || data.message || data.errors || 'Could not add to cart';
      throw new Error(typeof msg === 'string' ? msg : JSON.stringify(msg));
    }
    if (data.errors) {
      throw new Error(typeof data.errors === 'string' ? data.errors : JSON.stringify(data.errors));
    }
    return data;
  }

  /**
  * Refreshes the cart icon bubble count via Shopify's section rendering API.
  */
  async function refreshCartIconBubble() {
    try {
      const sections = await fetch(`${window.Shopify.routes.root}?sections=cart-icon-bubble`).then((res) => res.json());
      const el = document.getElementById('cart-icon-bubble');
      if (el && sections['cart-icon-bubble']) el.innerHTML = sections['cart-icon-bubble'];
    } catch (_) { /* non-critical */ }
  }

  /**
  * Adds to cart from the PDP button, refreshing the cart bubble and handling errors inline.
  */
  async function handlePDPAddToCart({ variantId }) {
    try {
      await addToShopifyCart({ variantId });
      await refreshCartIconBubble();
    } catch (err) {
      document.getElementById('add-to-cart-message').innerText = 'Failed to add item to cart. Please try again later.';
      const addToCartButton = document.getElementById('add-to-cart-button');
      if (addToCartButton) {
        addToCartButton.disabled = true;
      }
    }
  }

  /**
  * @returns the currently selected variant id based on the options selected
  */
  function getSelectedVariant(itemUuid) {
    try {
      if (itemUuid) {
        console.log(`Using item ${itemUuid}`);
        return Object.values(variantMap)[0];
      }
      const { variantId } = window.variants.getCurrentVariant() || {};
      if (variantId) {
        return variantMap[variantId.split('gid://shopify/ProductVariant/')[1]];
      }
      throw new Error('No variant found')
    } catch (err) {
      console.log(`Failed to find variant ${err}`);
      return null;
    }
  }

  /**
  * @returns the currently selected variant id based on the options selected
  */
  function getSelectedVariantId() {
    try{
      const { variantId } = window.variants.getCurrentVariant() || {};
      if (variantId) {
        return variantId.split('gid://shopify/ProductVariant/')[1];
      }
      throw new Error('No variant found')
    } catch (err) {
      console.log(`Failed to find variant ${err}`);
      return null;
    }
  }

  
  return {
    addToShopifyCart,
    handlePDPAddToCart,
    refreshCartIconBubble,
    getShopifyCart,
    getSelectedVariant,
    getSelectedVariantId,
  };
})();